// @flow
import Promise from 'bluebird';
import _ from 'lodash';

import api from '../api';
import ColorBrewer from '../core/tools/colorbrewer';
import environment from '../environment';
import ShapesControl from './ShapesControl';
import { Constants } from '../../constants/constants';

export class AreaClientControl extends ShapesControl {
  constructor () {
    const options = {
      id: 'area-selection',
      name: 'AreaClient',
      types: _.filter(environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES'), x => x.id === Constants.GM_DGA_ID),
      themes: _.filter(environment.get('CONFIG.FILTERS.MARKED_AREA_THEMES'), x => x.id !== Constants.DNC_FLEXIBLE),
      request: api.themes.get.area.sales,
      filter: true,
      overview: true
    };

    super(options);

    (this: any).colorize = this.colorize.bind(this);
    (this: any).select = this.select.bind(this);
  }

  static getInstance () {
    if (!AreaClientControl._instance) {
      AreaClientControl._instance = new AreaClientControl();
    }

    return AreaClientControl._instance;
  }

  select (value, options) {
    if (!options || _.isString(options)) {
      options = {
        remote: {
          method: 'GET',
          url: `${environment.get('API_HOST')}/localidade/GetLocation`,
          params: {
            locationType: value
          }
        }
      };
    }

    if (this.getControls().dropdown.data) {
      if (this._checkThemes(['industryRegistration'], null, value)) {
        this.getControls().dropdown.data.input.enable(false);
        this.getControls().dropdown.data.enable = false;
      } else {
        this.getControls().dropdown.data.input.enable(true);
        this.getControls().dropdown.data.enable = true;
      }
    }

    this.getControls().slider.opacity.input.enable(true);
    this.getControls().slider.opacity.enable = true;

    super.select(value, options);
  }

  colorize (featureCollection: any, layer: any) {
    return new Promise((resolve, reject) => {
      const id = layer.getMap()._id;

      if (!this.getControls(id).dropdown.data) {
        return resolve(featureCollection);
      }

      this.setThemeLayerOptions();

      super.colorize(featureCollection, layer).then(res => {
        if (this._checkThemes(['openPoint'])) {
          _.forEach(res.features, (f) => {
            if (_.isNumber(f.properties.Total)) {
              f.properties.Total = f.properties.Total > 0 ? 'Nominated' : 'Open Point';
            }
          });
        } else if (this._checkThemes(['locationName'])) {
          _.forEach(res.features, (f) => {
            f.properties.Total = f.properties.Nome;
          });
        }

        resolve(res);
      });
    });
  }

  setThemeLayerOptions () {
    const options = this.getLayer().options;
    if (this._checkThemes(['openPoint', 'locationName'])) {
      this.getControls().button.filter.input.enable(false);
      this.getControls().button.filter.enable = false;
      this.getControls().slider.range.input.enable(false);
      this.getControls().slider.range.enable = false;
      this.getControls().colorpicker.fillColor.input.value('Set2:6');
      this.getControls().colorpicker.fillColor.value = 'Set2:6';
      options.symbology.scale = 'nomenal';
      options.symbology.theme = ColorBrewer.Set2['6'];
    } else {
      this.getControls().colorpicker.fillColor.input.enable(true);
      this.getControls().colorpicker.fillColor.enable = true;
      options.symbology.scale = 'jenks';
      options.symbology.theme = ColorBrewer.OrRd[9];
    }
    this.getLayer().setOptions(options);
  }
}

export default AreaClientControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/AreaClientControl.js